import { App } from '@/console/host/app';
import { createAppRoot } from '@/shared/utils/create-app-root/create-app-root';

createAppRoot({
  app: <App />,
});
